var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.types, function (type) {
      return _c("CurrentPlanCard", {
        key: type,
        attrs: {
          type: type,
          "plan-action": _vm.currentPlansHash[type],
          plan:
            _vm.currentPlansHash[type] &&
            _vm.plansHash[_vm.currentPlansHash[type].planId],
          features: _vm.localFeatures,
          "trial-plan": _vm.trialInfo.remainingDays > 0,
        },
        on: {
          "show-plans": function ($event) {
            return _vm.showPlans(type)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }